import { doc, getDoc } from "firebase/firestore";
import { getClougStorage, getDB } from "./firebase";
import { getBlob, ref } from "firebase/storage";

const UNIT_ID_LENGTH = 8;
const SERIAL_CODE_UNITS_COLLECTION = "serial_code_units";
const CSV_MIME_TYPE = "text/csv";

function formatDate(d) {
  if(d) {
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const day = d.getDate();  
    return `${year}/${month}/${day}`;
  }
}

class SerialCodes {
  #orgCode = "";
  #unitId = "";
  #orgName = "";
  #packageName = "";
  #amount = 0;
  #availableFrom = "";
  #availableTo = "";
  #list = [];
  #pdfPath = "";
  #zipPath = "";

  constructor() {

  }

  reset() {
    this.#orgCode = "";
    this.#unitId = "";
    this.#orgName = "";
    this.#packageName = "";
    this.#amount = 0;
    this.#availableFrom = "";
    this.#availableTo = "";
    this.#list = [];
    this.#pdfPath = "";
    this.#zipPath = "";
  }

  get orgCode() {
    return this.#orgCode;
  }

  set orgCode(value) {
    this.#orgCode = value;
  }

  get unitId() {
    return this.#unitId;
  }

  set unitId(value) {
    if(value && value.length > UNIT_ID_LENGTH) {
      value = value.substring(0, UNIT_ID_LENGTH)
    }
    this.#unitId = value;
  }

  get orgName() {
    return this.#orgName;
  }

  get packageName() {
    return this.#packageName;
  }

  get amount() {
    return this.#amount;
  }

  get availableFrom() {
    return formatDate(this.#availableFrom);
  }

  get availableTo() {
    return formatDate(this.#availableTo);
  }

  get loaded() {
    return this.#list.length > 0;
  }

  validateInput() {
    return this.#orgCode && this.#orgCode.length > 4 && this.#unitId && this.#unitId.length === UNIT_ID_LENGTH;
  }

  getSerialCodes() {
    return new Promise(async (resolve, reject) => {
      if(!this.validateInput()) {
        reject("組織コードもしくはシリアルコードユニットIDが未入力です。");
      }

      const db = getDB();
      const id = `${this.#unitId}-${this.#orgCode}`;
      const docRef = doc(db, SERIAL_CODE_UNITS_COLLECTION, id);
      const docSnap = await getDoc(docRef);
      if(!docSnap.exists()) {
        reject("組織コードもしくはシリアルコードユニットIDが正しくありません。");
      }
      else {
        const data = docSnap.data();
        this.#orgName = data.org_name;
        this.#packageName = data.package_name;
        this.#amount = data.amount;
        this.#availableFrom = data.available_from.toDate();
        this.#availableTo = data.available_to.toDate();
        this.#list = data.serial_codes;
        //this.#pdfPath = data.pdf_path;
        //this.#zipPath = data.zip_path;
        this.#pdfPath = data.pdf_path ? data.pdf_path : `pdf/${data.unit_id}.pdf`;
        this.#zipPath = data.zip_path ? data.zip_path : `zip/${data.unit_id}.zip`;

        resolve(this);
      }
    });
  }

  getPdf() {
    return new Promise(async (resolve, reject) => {
      if(!this.#pdfPath) {
        reject("PDFデータが登録されていません。");
      }
      const storage = getClougStorage();
      const blob = await getBlob(ref(storage, this.#pdfPath));
      resolve(blob);
    });
  }

  getZip() {
    return new Promise(async (resolve, reject) => {
      if(!this.#zipPath) {
        reject("ZIPデータが登録されていません。");
      }
      const storage = getClougStorage();
      const blob = await getBlob(ref(storage, this.#zipPath));
      resolve(blob);
    });
  }

  getCsv() {
    return new Promise(async (resolve, reject) => {
      if(this.#list.length === 0) {
        reject("シリアルコードが登録されていません。");
      }
      const csvText = this.#list.join("\n");
      const blob = new Blob([csvText], {type: CSV_MIME_TYPE});
      resolve(blob);
    });
  }
}

let _serialCodes;
export function getSerialCodes() {
  if(!_serialCodes) {
    _serialCodes = new SerialCodes();
  }
  return _serialCodes;
}